module.exports = __webpack_public_path__ + "static/14-da7c5e5953e70f48fa368c9f5357b91a.jpg";